<!-- 首页新版操作按钮 -->
<template>
  <div class="btn-item" @click="handleClick">
    <div
      class="btn-item__icon"
      :style="{
        background
      }"
    >
      <!-- <img :src="imgSrc" /> -->
      <i :class="icon"></i>
    </div>
    <div class="btn-item__text">{{ name }}</div>
  </div>
</template>

<script>
export default {
  name: 'v-navigation-btn',
  props: {
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    type: {
      /**
       * 对应内部图标的颜色如下（图标分为两部分颜色：主色+副色，副色均为白色）
       * 1.按钮背景色蓝色，图标主色为：D9EBFF
       * 2.按钮背景色橙色，图标主色为：FDF5C7
       * 3.按钮背景色绿色，图标主色为：F4FEFE
       * 图标大小均为64
       */
      type: String,
      default: 'orange'
    }
  },
  computed: {
    background() {
      switch (this.type) {
        case 'orange':
          return 'linear-gradient(90deg, #FE8424 0%, #FC710A 100%)'
        case 'blue':
          return 'linear-gradient(90deg, #388EFA 0%, #337FFC 100%)'
        case 'green':
          return 'linear-gradient(90deg, #02DAB2 0%, #00CBA9 100%)'
        default:
          return 'linear-gradient(90deg, #FE8424 0%, #FC710A 100%)'
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="less" scoped>
.btn-item {
  width: 50px;
  height: auto;
  transition: all 0.2s;

  .btn-item__icon {
    width: 100%;
    height: 50px;
    border-radius: 10px;

    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 40px;
      height: 40px;
    }
    i {
      font-size: 26px;
      color: #fff;
    }
  }

  .btn-item__text {
    width: 100%;
    margin-top: 5px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    color: #000;
  }

  &:active {
    opacity: 0.5;
  }
}
</style>
